import { cacheKeys } from "@constants/cache-keys";
import { useExamContext } from "@features/exam/contexts/ExamContext";
import { useAppStore } from "@hooks/useAppStore";
import useClerkUser from "@hooks/useClerkUser";
import type { BaseItemSchema } from "@memorang/types/src/session/new-session";
import type { ReportDetails } from "@memorang/types/src/session/report";
import { useQueryClient } from "@tanstack/react-query";
import { useLocalSearchParams } from "expo-router";
import { usePrinting } from "../../hooks/usePrinting";
import PrintableReport from "./PrintableReport";

export default function PrintableReportContainer() {
	const { handleCancelPrint } = usePrinting();

	const queryClient = useQueryClient();
	const { id } = useLocalSearchParams<{ id: string }>();
	const { userPublicMetadataId: userId, email, userLogicalId } = useClerkUser();

	const {
		currentExamContext: { examName },
	} = useExamContext();

	const cachedData = queryClient.getQueryData<BaseItemSchema[]>([
		cacheKeys.sessionItems,
		id,
	]);

	const appName = useAppStore((state) => state.app.name);

	const reportDetails = queryClient.getQueryData<ReportDetails>([
		"report",
		id,
		userId,
	]);

	const assessmentName = reportDetails?.examName;
	const assessmentId = reportDetails?.numericId;

	if (!(examName && assessmentId && email && id)) {
		return null;
	}

	const data = {
		id: userLogicalId,
		email: email,
		assessment: assessmentName,
		assessmentId: assessmentId,
		appName,
		exam: examName,
		accuracy: `${reportDetails?.accuracy ?? 0}%`,
		tags: reportDetails?.tagDetails ?? [],
		items: cachedData ?? [],
		numericId: reportDetails?.numericId,
	};

	return <PrintableReport data={data} onCancel={handleCancelPrint} />;
}
